<template>
  <div ref="container" style="padding-top:8px;">
    <vonap-toolbar-label label="Currency">
      <select id="ccyPairDropDownList" style="width: 120px"></select>
    </vonap-toolbar-label>
    <vonap-toolbar-label label="Unit">
      <label v-if="!isCommodity" style="margin-right:14px;font-weight:400;top:2px;position:relative"
        >{{ ccyPairUnit }}
      </label>
      <span v-show="isCommodity">
        <select id="unitDropDownList" style="width: 100px"></select>
      </span>
    </vonap-toolbar-label>
    <vonap-toolbar-label label="Report Date">
      <input id="periodControl" style="width: 125px;" />
    </vonap-toolbar-label>
    <vonap-toolbar-label label="From">
      <select id="fromDateDropDownList" style="width: 105px"></select>
    </vonap-toolbar-label>
    <vonap-toolbar-label label="To">
      <select id="toDateDropDownList" style="width: 105px"></select>
    </vonap-toolbar-label>
    <vonap-toolbar-label label="Sector">
      <select id="sectorDropDownList" style="width: 170px"></select>
    </vonap-toolbar-label>
    <vonap-toolbar-label label="Division">
      <select id="divisionDropDownList" style="width: 170px"></select>
    </vonap-toolbar-label>
    <vonap-toolbar-label label="Forwards or options">
      <kendo-dropdownlist
        title="Option"
        id="optionDropDownList"
        :data-source="optionDataSource"
        :data-text-field="'text'"
        :data-value-field="'value'"
        :change="optionDropDownChange"
        v-show="showOptionDropDown"
        style="width: 125px;"
      >
      </kendo-dropdownlist>
    </vonap-toolbar-label>
    <label v-show="showQuarter"> Quarter:<input type="checkbox" id="quarterViewCheckBox"/></label>
    <label v-show="showHistorical">
      Historical:<input type="checkbox" id="historicalViewCheckBox"
    /></label>
    <slot v-bind:toolbar="toolbar">
      <kendo-button type="button" @click="onExport" icon="excel" title="Export to Excel" />
    </slot>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
const $ = kendo.jQuery

export default {
  name: 'ExposureToolbarV4',
  components: {
    VonapToolbarLabel,
  },
  props: {
    showQuarter: {type: Boolean, default: false},
    showHistorical: {type: Boolean, default: true},
    showOptionDropDown: {type: Boolean, default: false},
    marketId: {type: Number, required: true},
  },
  data() {
    return {
      toolbar,
      ccyPairUnit: '',
      unitId: 0, //currency
      ratio: 0,
      foreignCcyMarketId: -1,
      foreignCcy: '',
      ccyPairId: 0,
      optionDataSource: [
        {text: 'All', value: 0},
        {text: 'Option Only', value: 1},
        {text: 'Forward Only', value: 2},
      ],
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    isCommodity() {
      return this.foreignCcyMarketId != 1
    },
  },
  methods: {
    optionDropDownChange() {
      this.emitChangeEvent()
    },
    emitChangeEvent() {
      this.$emit('change', toolbar.getSelectedValues())
    },
    onExport() {
      this.$emit('export', toolbar.getSelectedValues())
    },
  },
  mounted() {
    toolbar.createToolbar(this).then(() => {
      this.emitChangeEvent()
    })
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
  },
}

const toolbar = (() => {
  'use strict'
  let period,
    divisionDropDownList,
    fromDateDropDownList,
    toDateDropDownList,
    ccyPairDropDownList,
    unitDropDownList,
    sectorDropDownList

  let vm

  function createExposureToolbar() {
    return new Promise(function(resolve) {
      resolve()
      return
    }).then(function() {
      return new Promise(function(toolbarResolve) {
        period = $('#periodControl')
          .kendoDatePicker({
            format: 'yyyy-MM-dd',
            value: kendo.parseDate(localStorage.getItem('reportDate')) || new Date(),
            change: async e => {
              localStorage.setItem('reportDate', kendo.toString(e.sender.value(), 'yyyy-MM-dd'))
              await fromDateDropDownList.dataSource.read()
              fromDateDropDownList.select(0)
              await toDateDropDownList.dataSource.read()
              toDateDropDownList.select(0)
              vm.emitChangeEvent()
            },
          })
          .getKendoDatePicker()
        //connect change event quarter view checkbox
        $('#quarterViewCheckBox').change(function() {
          $('#quarterViewCheckBox').is(':checked')
          vm.emitChangeEvent()
        })

        $('#historicalViewCheckBox').change(async () => {
          await fromDateDropDownList.dataSource.read()
          fromDateDropDownList.select(0)
          await toDateDropDownList.dataSource.read()
          vm.emitChangeEvent()
        })

        //cascade dropdown lists
        sectorDropDownList = $('#sectorDropDownList')
          .kendoDropDownList({
            dataTextField: 'sector',
            dataValueField: 'sectorId',
            dataSource: {
              transport: {
                read: {
                  url: '/api/report/ExposureToolbar/GetUserSectors',
                  cache: false,
                  data: function() {
                    return {
                      clientId: vm.clientId,
                    }
                  },
                },
              },
            },
            index: 0,
            change: async () => {
              await divisionDropDownList.dataSource.read()
              divisionDropDownList.select(0)
              await ccyPairDropDownList.dataSource.read()
              ccyPairDropDownList.select(0)
              await fromDateDropDownList.dataSource.read()
              fromDateDropDownList.select(0)
              await toDateDropDownList.dataSource.read()
              toDateDropDownList.select(0)
              ccyPairDropDownList.select(0)
              vm.emitChangeEvent()
            },
          })
          .data('kendoDropDownList')

        return new Promise(function(sectorResolve) {
          sectorDropDownList.bind('dataBound', function() {
            sectorResolve()
          })
        })
          .then(function() {
            divisionDropDownList = $('#divisionDropDownList')
              .kendoDropDownList({
                dataTextField: 'divisionName',
                dataValueField: 'divisionId',
                dataSource: {
                  transport: {
                    read: {
                      url: '/api/report/ExposureToolbar/GetUserDivisions',
                      cache: false,
                      data: function() {
                        return {
                          sectorId: sectorDropDownList.value(),
                          clientId: vm.clientId,
                        }
                      },
                    },
                  },
                },
                index: 0,
                change: async () => {
                  await ccyPairDropDownList.dataSource.read()
                  ccyPairDropDownList.select(0)
                  await fromDateDropDownList.dataSource.read()
                  fromDateDropDownList.select(0)
                  await toDateDropDownList.dataSource.read()
                  toDateDropDownList.select(0)
                  ccyPairDropDownList.select(0)
                  vm.emitChangeEvent()
                },
              })
              .data('kendoDropDownList')

            return new Promise(function(resolve) {
              divisionDropDownList.bind('dataBound', function() {
                resolve()
              })
            })
          })
          .then(function() {
            ccyPairDropDownList = $('#ccyPairDropDownList')
              .kendoDropDownList({
                dataTextField: 'pairCode',
                dataValueField: 'ccyPairId',
                dataSource: {
                  transport: {
                    read: {
                      url: '/api/report/ExposureToolbar/GetCcyPairsV4',
                      cache: false,
                      data: () => {
                        return {
                          divisionId: divisionDropDownList.value(),
                          clientId: vm.clientId,
                          marketId: vm.marketId,
                        }
                      },
                    },
                  },
                },
                index: 0,
                dataBound: function() {
                  ccyPairDropDownList.select(0)
                  let item = ccyPairDropDownList.dataItem()
                  vm.ccyPairUnit = item ? item.unit : ''
                  vm.foreignCcyMarketId = item.foreignCcyMarketId
                  vm.foreignCcy = item.foreignCcy
                  vm.ccyPairId = item.ccyPairId
                },
                change: async e => {
                  await fromDateDropDownList.dataSource.read()
                  fromDateDropDownList.select(0)
                  await toDateDropDownList.dataSource.read()
                  toDateDropDownList.select(0)

                  //vm.$emit('change', getSelectedValues())
                  vm.ccyPairUnit = e.sender.dataItem().unit
                  vm.foreignCcyMarketId = e.sender.dataItem().foreignCcyMarketId
                  vm.foreignCcy = e.sender.dataItem().foreignCcy
                  vm.ccyPairId = e.sender.value()

                  await unitDropDownList.dataSource.read()
                  unitDropDownList.select(0)
                  //unitDropDownList.trigger('change')
                },
              })
              .data('kendoDropDownList')

            return new Promise(function(resolve) {
              ccyPairDropDownList.bind('dataBound', function() {
                resolve()
              })
            })
          })
          .then(function() {
            unitDropDownList = $('#unitDropDownList')
              .kendoDropDownList({
                dataTextField: 'unitName',
                dataValueField: 'unitId',
                dataSource: {
                  transport: {
                    read: {
                      type: 'GET',
                      contentType: 'application/json',
                      url: '/api/FlowTypeToolbar/getUnits',
                      data: () => ({
                        marketId: vm.foreignCcyMarketId,
                        ccyPairId: vm.ccyPairId,
                        clientId: vm.clientId,
                      }),
                    },
                  },
                },
                index: 0,
                change: e => {
                  vm.unitId = e.sender.value()
                  vm.ratio = e.sender.dataItem().ratio
                  vm.emitChangeEvent()
                },
                dataBound: e => {
                  unitDropDownList.select(0)
                  vm.unitId = e.sender.value()
                  vm.ratio = e.sender.dataItem().ratio
                },
              })
              .data('kendoDropDownList')

            return new Promise(function(resolve) {
              unitDropDownList.bind('dataBound', function() {
                resolve()
              })
            })
          })
          .then(function() {
            fromDateDropDownList = $('#fromDateDropDownList')
              .kendoDropDownList({
                dataTextField: 'periodCode',
                dataValueField: 'toDate',
                dataSource: {
                  transport: {
                    read: {
                      type: 'get',
                      url: '/api/report/ExposureToolbar/GetFromPeriods',
                      cache: false,
                      data: function() {
                        return {
                          asOfDate: kendo.toString(period.value(), 'yyyy-MM-dd'),
                          sectorId: sectorDropDownList.value(),
                          divisionId: divisionDropDownList.value(),
                          ccyPairId: ccyPairDropDownList.value(),
                          historical: $('#historicalViewCheckBox').is(':checked'),
                          clientId: vm.clientId,
                        }
                      },
                    },
                  },
                },
                index: 0,
                change: async () => {
                  await toDateDropDownList.dataSource.read()
                  toDateDropDownList.select(0)
                  vm.emitChangeEvent()
                },
              })
              .data('kendoDropDownList')

            return new Promise(function(resolve) {
              fromDateDropDownList.bind('dataBound', function() {
                resolve()
              })
            })
          })
          .then(function() {
            toDateDropDownList = $('#toDateDropDownList')
              .kendoDropDownList({
                dataTextField: 'periodCode',
                dataValueField: 'toDate',
                dataSource: {
                  transport: {
                    read: {
                      url: '/api/report/ExposureToolbar/GetToPeriods',
                      cache: false,
                      data: function() {
                        return {
                          asOfDate: kendo.toString(period.value(), 'yyyy-MM-dd'),
                          sectorId: sectorDropDownList.value(),
                          divisionId: divisionDropDownList.value(),
                          ccyPairId: ccyPairDropDownList.value(),
                          fromDate: fromDateDropDownList.value(),
                          clientId: vm.clientId,
                        }
                      },
                    },
                  },
                },
                index: 0,
                change: function() {
                  vm.emitChangeEvent()
                },
              })
              .data('kendoDropDownList')

            return new Promise(function(resolve) {
              toDateDropDownList.bind('dataBound', function() {
                resolve()
              })
            })
          })
          .then(function() {
            toolbarResolve()
          })
      })
    })
  }

  function getSelectedValues() {
    return {
      clientId: vm.clientId,
      asOfDate: kendo.toString(period.value(), 'yyyy-MM-dd'),
      fromDate: fromDateDropDownList.value(),
      toDate: toDateDropDownList.value(),
      sectorId: sectorDropDownList.value(),
      divisionId: divisionDropDownList.value(),
      ccyPairId: ccyPairDropDownList.value(),
      unitId: vm.unitId,
      ratio: vm.ratio,
      foreignCcyMarketId: vm.foreignCcyMarketId,
      foreignCcy: vm.foreignCcy,
      ccyPair: ccyPairDropDownList.text(),
      foreignCcyIsFx: ccyPairDropDownList.dataItem().foreignIsFx,
      optionValue: $('#optionDropDownList')
        .data('kendoDropDownList')
        .value(),
      quarterView: $('#quarterViewCheckBox').is(':checked'),
      historicalView: $('#historicalViewCheckBox').is(':checked'),
      marketId: vm.marketId,
    }
  }
  function getCcyPairIsFx() {
    return true
  }

  return {
    createToolbar($vm) {
      vm = $vm
      return createExposureToolbar()
    },
    getSelectedValues: getSelectedValues,
    getCcyPairIsFx: getCcyPairIsFx,
  }
})()
</script>
